import React from 'react';

/*
 * Pictogrammes "maison FFTT" : formes pleines, géométriques, monochromes
 * (calqués sur la charte graphique FF Tennis de Table 2025, p.27).
 * fill="currentColor" => la couleur est pilotée en CSS (blanc dans la navbar).
 */

const base = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    'aria-hidden': true,
    focusable: false,
    className: 'navbar_undernav_icon',
};

// PRESENTATION -> maison (avec porte évidée)
export const IconPresentation = () => (
    <svg {...base}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2.2 21.5 10v11.5h-19V10L12 2.2Zm-2.8 19.3v-5.7a2.8 2.8 0 0 1 5.6 0v5.7H9.2Z"
        />
    </svg>
);

// CLUBS -> repère de localisation (avec pastille évidée)
export const IconClubs = () => (
    <svg {...base}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2c-4.4 0-8 3.5-8 7.9 0 5.4 8 12.6 8 12.6s8-7.2 8-12.6C20 5.5 16.4 2 12 2Zm0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
        />
    </svg>
);

// CALENDRIERS/RESULTATS -> calendrier (bandeau plein + grille de points évidés)
export const IconCalendrier = () => (
    <svg {...base}>
        <rect x="6.5" y="2" width="2.6" height="4.5" rx="1.3" />
        <rect x="14.9" y="2" width="2.6" height="4.5" rx="1.3" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 4h16a1.6 1.6 0 0 1 1.6 1.6v14.8A1.6 1.6 0 0 1 20 22H4a1.6 1.6 0 0 1-1.6-1.6V5.6A1.6 1.6 0 0 1 4 4Zm3 7.4a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Zm5 0a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Zm5 0a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Zm-10 4.6a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Zm5 0a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Zm5 0a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Z"
        />
    </svg>
);

// CLASSEMENT -> barres de podium
export const IconClassement = () => (
    <svg {...base}>
        <path d="M3 21V13.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V21H3Zm7.5 0V4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v17h-3Zm7.5 0V9.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V21h-6Z" />
    </svg>
);

// STATISTIQUES -> diagramme circulaire (part détachée)
export const IconStatistiques = () => (
    <svg {...base}>
        <path d="M11 13V4.5a8.5 8.5 0 1 0 8.5 8.5H11Z" />
        <path d="M13 11V2.5a8.5 8.5 0 0 1 8.5 8.5H13Z" />
    </svg>
);

// CONTACTS -> bulle de dialogue
export const IconContacts = () => (
    <svg {...base}>
        <path d="M4 4h16a1.6 1.6 0 0 1 1.6 1.6v9.8A1.6 1.6 0 0 1 20 17h-8.2l-5 4v-4H4a1.6 1.6 0 0 1-1.6-1.6V5.6A1.6 1.6 0 0 1 4 4Z" />
    </svg>
);

// PLAYOFFS -> coupe
export const IconPlayoffs = () => (
    <svg {...base}>
        <path d="M6 2.5h12V4h3.2v2.6a4.6 4.6 0 0 1-4.1 4.6 6 6 0 0 1-3.9 3.2V17H16a1.5 1.5 0 0 1 1.5 1.5v3h-11v-3A1.5 1.5 0 0 1 8 17h2.8v-2.6a6 6 0 0 1-3.9-3.2 4.6 4.6 0 0 1-4.1-4.6V4H6V2.5Zm0 3.6H4.9v.5A2.5 2.5 0 0 0 6.3 8.9 6.1 6.1 0 0 1 6 7V6.1Zm12 0V7a6.1 6.1 0 0 1-.3 1.9 2.5 2.5 0 0 0 1.4-2.3v-.5H18Z" />
    </svg>
);

// Repli par défaut -> flèche pleine
export const IconDefault = () => (
    <svg {...base}>
        <path d="M8 3.5 18 12 8 20.5 6 18.2 13.2 12 6 5.8Z" />
    </svg>
);

// Icône d'une entrée du sous-menu, d'après sa page (le libellé, lui, dépend de la langue)
export const getUnderNavIcon = (redirection) => {
    switch (redirection) {
        case '/presentation':
            return <IconPresentation />;
        case '/joueurs':
            return <IconClubs />;
        case '/calendrier':
            return <IconCalendrier />;
        case '/playoffs':
            return <IconPlayoffs />;
        case '/classement':
            return <IconClassement />;
        case '/statistiques':
            return <IconStatistiques />;
        case '/clubs':
            return <IconContacts />;
        default:
            return <IconDefault />;
    }
};
